import { CampaignId } from 'mini-campaign-bootstrap/lib/schema/CampaignId';
import { CustomCallbackFunctions } from 'mini-campaign/lib/store/schema/CustomCallbackFunctions';
import { logErrorToCauseAlert } from '../analytics/webpushAnalytics';
import {
    lazyIncrementPushNotificationsOnboardingCount,
    lazyUpdatePartialUserPreference,
    lazyUserInitiatedWebPushSetupWorkflow,
} from '..';

/**
 * utility function which returns the callback functions for the push notifications onboarding campaign
 * @param secondaryButtonCb Callback function of the Secondary button
 */
export const getPushNotificationsSurfaceCustomCallback = (
    secondaryButtonCb
): Partial<Record<CampaignId, CustomCallbackFunctions>> => {
    const customCallbackFunctions = {};
    customCallbackFunctions[CampaignId.MiniPushNotifications] = {
        onPrimaryButtonClick,
        onSecondaryButtonClick: secondaryButtonCb,
        onTertiaryButtonClick: () =>
            lazyUpdatePartialUserPreference.importAndExecute({ onboardingDisabled: true }),
        onRender: () => lazyIncrementPushNotificationsOnboardingCount.importAndExecute(),
    };
    return customCallbackFunctions;
};

const onPrimaryButtonClick = async () => {
    try {
        await lazyUserInitiatedWebPushSetupWorkflow.importAndExecute({
            windowObj: window,
            shouldShowToast: true,
        });
    } catch (error) {
        logErrorToCauseAlert('Unable to enable notifications from onboarding', error);
    }
};
